import React, { useState } from 'react';
import {
  FormControl,
  FormControlLabel,
  FormLabel,
  Radio,
  RadioGroup,
  Button,
  Box,
  Container,
  Grid,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from '@mui/material';
import { DocumentData } from '@google-cloud/firestore';
import { submitBreastForm } from '../../services';
import { Print } from '@mui/icons-material';
import { FormTextField } from '../custom/CustomComponents';

export interface IBreastFormData {
  survivor: string;
  attendingSeminar: string;
  firstName: string;
  lastName: string;
  // address: string;
  // city: string;
  // state: string;
  // zip: string;
  email: string;
  phone: string;
  //gender?: string;
}

const REGISTRATION_DEADLINE = new Date('2026-10-08T00:00:00');

const BreastCancer = ({ form = null }: { form?: DocumentData | null }) => {
  const expired = false;
  const deadlinePassed = new Date() >= REGISTRATION_DEADLINE;
  const [isLoading, setIsLoading] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [state, setState] = useState<IBreastFormData>(
    (form || {
      survivor: 'No',
      attendingSeminar: 'Yes',
      email: '',
      phone: '',
      // gender: 'Female',
    }) as IBreastFormData
  );

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setState({
      ...state,
      [name]: value,
    });
  };

  //   const handleChange2 = (e: SelectChangeEvent<string>) => {
  //     const { name, value } = e.target;
  //     setState({
  //       ...state,
  //       [name]: value,
  //     });
  //   };

  const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setIsLoading(true);
    submitBreastForm(state)
      .then(() => {
        setShowModal(true);
      })
      .catch(() => {
        alert('Error Submitting');
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  const { firstName, lastName } = state;
  const isDisabled = !firstName && !lastName;
  const formDisabled = form !== null;

  if (expired) {
    return (
      <Dialog
        open={true}
        onClose={() => {}}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          Registration Capacity Reached{' '}
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            Thank you for your interest in registering for our Tenth Annual
            Breast Health Awareness Community Seminar. We have reach capacity
            and registration is now closed. We hope to see you next year.
            Blessings to you.
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => {
              window.location.href = '/';
            }}
          >
            OK
          </Button>
        </DialogActions>
      </Dialog>
    );
  }

  if (!form && deadlinePassed) {
    return (
      <Dialog
        open={true}
        onClose={() => {}}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          Registration Deadline Passed
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            Thank you for your interest in registering for our 13th Annual
            Community Breast Health Awareness Seminar. The registration deadline
            has passed and we are no longer accepting new registrations. We hope
            to see you next year. Blessings to you.
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => {
              window.location.href = '/';
            }}
          >
            OK
          </Button>
        </DialogActions>
      </Dialog>
    );
  }
  return (
    <Box sx={{ margin: '2rem' }}>
      <Container
        sx={{
          width: {
            md: '50%',
            xs: '100%',
            // backgroundImage: `url(${require('../../images/breast_cancer_2024.png')})`,
            backgroundRepeat: 'no-repeat',
            backgroundPositionX: 'right',
          },
        }}
      >
        {formDisabled && (
          <div className="no-print">
            <Button variant="contained" startIcon={<Print />} onClick={print}>
              Print Completed Form
            </Button>
          </div>
        )}
        <h3>EVENT REGISTRATION</h3>

        <div style={{ marginBottom: -15, marginTop: '0rem' }}>13th Annual</div>
        <h4>COMMUNITY BREAST HEALTH AWARENESS SEMINAR</h4>
        <h4 style={{ color: 'deeppink' }}>
          SATURDAY OCTOBER 10, 2026 | 9:00 AM - 11:30 AM
        </h4>
        <form onSubmit={handleSubmit}>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <FormControl component="fieldset">
                <FormLabel component="legend">
                  Are you a breast cancer survivor?
                </FormLabel>
                <RadioGroup
                  row
                  name="survivor"
                  value={state.survivor}
                  onChange={handleChange}
                >
                  <FormControlLabel
                    value="Yes"
                    control={<Radio />}
                    label="Yes"
                    disabled={formDisabled}
                  />
                  <FormControlLabel
                    value="No"
                    control={<Radio />}
                    label="No"
                    disabled={formDisabled}
                  />
                </RadioGroup>
              </FormControl>
            </Grid>
            <Grid item xs={12}>
              <FormControl component="fieldset">
                <FormLabel component="legend">
                  Will you be attending the seminar?
                </FormLabel>
                <RadioGroup
                  row
                  name="attendingSeminar"
                  value={state.attendingSeminar}
                  onChange={handleChange}
                >
                  <FormControlLabel
                    value="Yes"
                    control={<Radio />}
                    label="Yes"
                    disabled={formDisabled}
                  />
                  <FormControlLabel
                    value="No"
                    control={<Radio />}
                    label="No"
                    disabled={formDisabled}
                  />
                </RadioGroup>
              </FormControl>
            </Grid>
            <Grid item xs={12} md={6}>
              <FormTextField
                disabled={formDisabled}
                fullWidth
                margin="normal"
                name="firstName"
                label="First Name"
                value={state.firstName}
                onChange={handleChange}
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <FormTextField
                disabled={formDisabled}
                fullWidth
                margin="normal"
                name="lastName"
                label="Last Name"
                value={state.lastName}
                onChange={handleChange}
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <FormTextField
                disabled={formDisabled}
                fullWidth
                margin="normal"
                name="email"
                label="E-mail"
                value={state.email}
                onChange={handleChange}
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <FormTextField
                disabled={formDisabled}
                fullWidth
                margin="normal"
                name="phone"
                label="Phone Number"
                value={state.phone}
                onChange={handleChange}
              />
            </Grid>
            <Grid>
              <p style={{ fontWeight: 'bold', lineHeight: 1.5 }}>
                Seminar-themed T-shirts and Caps are available for purchase in
                advance of the seminar. Click this link to order today:{' '}
                <a href="/order" target="_blank" rel="noreferrer">
                  www.nmzlakeland.org/order
                </a>
              </p>
            </Grid>
          </Grid>
          {!form && (
            <Button
              variant="contained"
              color="primary"
              type="submit"
              style={{ marginTop: '0em' }}
              disabled={isDisabled || isLoading}
              startIcon={isLoading ? <CircularProgress size={20} /> : null}
            >
              {isLoading ? 'Submitting...' : 'Submit'}
            </Button>
          )}

          <Dialog
            open={showModal}
            onClose={() => {}}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
          >
            <DialogTitle id="alert-dialog-title">
              Registration Submitted
            </DialogTitle>
            <DialogContent>
              <DialogContentText id="alert-dialog-description">
                Thank you for registering
              </DialogContentText>
            </DialogContent>
            <DialogActions>
              <Button
                onClick={() => {
                  window.location.href = '/';
                }}
              >
                OK
              </Button>
            </DialogActions>
          </Dialog>
        </form>
      </Container>
    </Box>
  );
};

export default BreastCancer;
